import { selectSelectedSubscription } from "../../redux/selectors/subscription.selector";
import EditIcon from "@mui/icons-material/EditOutlined";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { PowerBIUtils } from "../../utils/powerBi.utils";
import { userFacilities } from "../../redux/selectors/user.selector";
import { useEffect, useState } from "react";
import { getUniquePortfoliosValues, getUniqueRegionsValues, getUniqueFacilities, getUniquePortfoliosNames } from "../HomePage/portfolio-utils";
import { Select, MenuItem, Checkbox, InputBase, styled } from "@mui/material";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { subscriptionActions } from "../../redux/actions/subscription.actions";


export interface ReportExportFiltersProps {
  action: string;
  admin: boolean;
}

const InputLarge = styled(InputBase)(({ theme }) => ({
  "& .MuiInputBase-input": {
    backgroundColor: "rgba(85, 136, 163, 0.2)",
    borderBottom: "2px solid #5588a3",
    fontSize: "1em",
    padding: "6px 5px 5px 12px",
    transition: theme.transitions.create(["border-color", "box-shadow"]),
    "&:focus": {
      borderColor: "#5588a3",
    },
  },
}));

function ReportExportFilters({ action, admin }: Readonly<ReportExportFiltersProps>) {
  const userFacilitiesList = useSelector(userFacilities);
  const dispatch = useDispatch();

  const uniqueNames = getUniquePortfoliosNames(userFacilitiesList, 'portfolioId');
    const uniqueRegionNames = getUniqueRegionsValues(userFacilitiesList, 'regionId');
    const uniqueFacilities = getUniqueFacilities(userFacilitiesList, 'facilityId');
  const [selectedFacilities,setSelectedFacilities]= useState<any[]>(userFacilitiesList)
  const [selectedFacilityIds,setSelectedFacilityIds]= useState<any[]>([])
  const [selectedPortfolioIds,setSelectedPortfolioIds]= useState<any[]>([])
  const selectedSubscription = useSelector(selectSelectedSubscription);


  useEffect(()=>{
    console.log(uniqueNames)
    console.log(uniqueRegionNames)
    console.log(uniqueFacilities)
  },[])

  const handlePortfolioChange=(e:any)=>{
    const {
      target: { value },
    } = e;

    const ids = typeof value === "string" ? value.split(",") : value;
    setSelectedPortfolioIds(ids);
    const facilities = ids.map((pn:string)=>{
      return userFacilitiesList.filter((p)=>p.portfolioName==pn)
    });
    const mergedArray = facilities.reduce((acc:any, curr:any) => acc.concat(curr), []);
    console.log(mergedArray)
    setSelectedFacilities(mergedArray)
    selectedSubscription.ExportPortfolios=ids.join();
    setSelectedFacilityIds([])
    dispatch(subscriptionActions.setSubscriptionExportPortfolios(ids.join()));
  }
  const handleFacilityChange=(e:any)=>{
    console.log(selectedFacilityIds)
    const {
      target: { value },
    } = e;

    const ids = typeof value === "string" ? value.split(",") : value;
    setSelectedFacilityIds(ids);
    selectedSubscription.ExportFacilities=ids.join();
    dispatch(subscriptionActions.setSubscriptionExportFacilities(ids.join()));

  }

  return (
    <div className="report-filters">
      <div className="select-lable"> Export Portfolio 
      <div className="control-cell">
            <Select
            className="select-xlarge"
            value={selectedPortfolioIds}
            onChange={handlePortfolioChange}
            input={<InputLarge />}
            IconComponent={KeyboardArrowDownIcon}
            renderValue={(selected) =>
              uniqueNames?.filter((x) =>
                  selectedPortfolioIds.includes(x.portfolioName)
                )
                .map((x) => x.portfolioName)
                .join(", ")
            }
            multiple
          >
            {uniqueNames?.map((x) => {
                return (
                  <MenuItem
                    key={x.portfolioId}
                    value={x.portfolioName}
                    className="medium-text blue-text"
                  >
                    <Checkbox
                      checked={selectedPortfolioIds.indexOf(x.portfolioName) > -1}
                    />
                    {x.portfolioName}
                  </MenuItem>
                );
              })}
          </Select>
        </div>
        </div>
        <div className="select-lable"> Export Facilities 
        {/* <select>
                {selectedFacilities.map((p,i)=>{
                  return <option value={p.facilityId}>{p.facilityName}</option>
                })}
            </select> */}
            <Select
            className="select-xlarge"
            value={selectedFacilityIds}
            onChange={handleFacilityChange}
            input={<InputLarge />}
            IconComponent={KeyboardArrowDownIcon}
            renderValue={(selected) =>
              selectedFacilities?.filter((x) =>
                  selectedFacilityIds.includes(x.facilityName)
                )
                .map((x) => x.facilityName)
                .join(", ")
            }
            multiple
          >
            {selectedFacilities?.map((x) => {
                return (
                  <MenuItem
                    key={x.facilityId}
                    value={x.facilityName}
                    className="medium-text blue-text"
                  >
                    <Checkbox
                      checked={selectedFacilityIds.indexOf(x.facilityName) > -1}
                    />
                    {x.facilityName}
                  </MenuItem>
                );
              })}
          </Select>
        </div>
        {/* <div className="select-lable"> Export Filters 
        <select>
                <option>Interactive</option>
                <option>Report</option>
            </select>
        </div> */}
        
    </div>
  );
}

export default ReportExportFilters;
